export enum WriteModeEnum {
  create = 'create',
  update = 'update',
}

export type WriteMode = WriteModeEnum.create | WriteModeEnum.update;
